import { json } from '@remix-run/node'

import getApp from '~/utils/getApp'
import getScope from '~/utils/scope'

import itemResolver from '~/services/resolvers/item'
import metaResolver from '~/services/resolvers/meta'
import { ItemType } from '~/services/resolvers/item/types'

import serverErrorHandler from '~/utils/serverErrorHandler'

import {
    MarketGuide as MarketGuideApp,
    Jobs as JobsApp,
    ChurchEvent as ChurchEventApp
} from '~/config/apps'

import type {
    LoaderFunction,
    MetaFunction
} from '@remix-run/node'

export const loader: LoaderFunction = async ({ request, params }) => {
    if (params.id) {
        const url = request.url
        
        const app = getApp(url)

        if (app instanceof Response) {
            return app
        }

        if (
            app.id === MarketGuideApp.id ||
            app.id === JobsApp.id ||
            app.id === ChurchEventApp.id
        ) {
            const scope = getScope(app, request.url)
            
            if (scope instanceof Response) {
                return scope
            }

            try {
                const { result, _type } = await itemResolver({
                    app: app,
                    url: url,
                    scope: scope,
                    id: params.id
                })
                
                return json({
                    _type: _type,
                    app: app,
                    scope: scope,
                    payload: result
                })
            } catch (error: any) {
                await serverErrorHandler(request, error, scope.id)

                return json({
                    _type: app.id === MarketGuideApp.id ? ItemType.Company : ItemType.Job,
                    app: app,
                    scope: scope,
                    payload: {}
                })
            }
        } else {
            throw new Response(`Unknown app to resolve route from`, {
                status: 400
            })
        }
    } else {
        throw new Response('Item not found!', {
            status: 404
        })
    }
}

export const meta: MetaFunction = ({ data }) => {
    const metaPayload = metaResolver(data)

    return metaPayload
}

export { default } from '~/pages/ItemPage'